export default __webpack_public_path__ + "static/media/new.b76c036b.svg";